import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React, { useContext } from 'react';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import { CommentEditorProviders } from '../../../CommentEditor/context';
import CommentBoxRoot from '../../lego/CommentBoxRoot';
/**
 * A skeleton of our CommentBox that includes the `<CommentEditorProviders />`
 * and some customizable view slots that change visibility based on the comment editor state.
 */ const CommentBoxSkeleton = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id , loggedOutView , editorView , cantPostView , editComment , replyComment , isSmall , canPostComment =true , className  } = _param, rest = _object_without_properties(_param, [
        "id",
        "loggedOutView",
        "editorView",
        "cantPostView",
        "editComment",
        "replyComment",
        "isSmall",
        "canPostComment",
        "className"
    ]);
    const { isLoggedIn  } = useContext(SessionContext);
    return /*#__PURE__*/ React.createElement(CommentEditorProviders, _extends({
        commentBoxId: id,
        editorSource: editComment ? CommentEditorSource.Edit : replyComment ? CommentEditorSource.Reply : CommentEditorSource.Independent,
        relevantComment: editComment || replyComment
    }, rest), /*#__PURE__*/ React.createElement(CommentBoxRoot, {
        className: className,
        isSmall: isSmall,
        ref: ref
    }, !isLoggedIn && loggedOutView, isLoggedIn && (canPostComment ? editorView : cantPostView)));
});
CommentBoxSkeleton.displayName = 'CommentBoxSkeleton';
export default CommentBoxSkeleton;
